import { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { Container } from '@/components/common';
import { routes } from '@/config/routes';
import { env } from '@/config/env';
import { useAppStore } from '@/state/appStore';

import { DesktopNavigation } from './DesktopNavigation';
import { AccountMenu } from './AccountMenu';
import { MobileNavigation } from './MobileNavigation';
import { SearchOverlay } from './SearchOverlay';

export function PublicHeader() {
  const [searchOpen, setSearchOpen] = useState(false);
  const mobileOpen = useAppStore((state) => state.mobileNavigationOpen);
  const setMobileOpen = useAppStore((state) => state.setMobileNavigationOpen);
  const menuButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <header className="public-header">
        <Container className="public-header__inner" size="wide">
          <button
            className="icon-button public-header__menu-button"
            ref={menuButtonRef}
            type="button"
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className="pi pi-bars" aria-hidden="true" />
          </button>
          <NavLink className="wordmark" to={routes.home} aria-label={`${env.appName} home`}>
            <span className="wordmark__mark" aria-hidden="true">
              E
            </span>
            <span>{env.appName}</span>
          </NavLink>
          <DesktopNavigation />
          <div className="header-actions">
            <button
              className="icon-button"
              type="button"
              aria-label="Search"
              onClick={() => setSearchOpen(true)}
            >
              <i className="pi pi-search" aria-hidden="true" />
            </button>
            <AccountMenu />
            <NavLink
              className="icon-button cart-action"
              to={routes.checkout}
              aria-label="Cart, 0 items"
            >
              <i className="pi pi-shopping-bag" aria-hidden="true" />
              <span aria-hidden="true">0</span>
            </NavLink>
          </div>
        </Container>
      </header>
      <MobileNavigation menuButtonRef={menuButtonRef} onSearch={() => setSearchOpen(true)} />
      <SearchOverlay visible={searchOpen} onHide={() => setSearchOpen(false)} />
    </>
  );
}
